// src/components/Experiment/JobSelectionCard.js
import React from 'react';
import { Card, Button, Badge, Spinner } from 'react-bootstrap';
import useImageWithAuth from '../../hooks/useImageWithAuth';

const JobSelectionCard = ({
  job,
  onAdd,
  onRemove,
  showAddButton = false,
  showRemoveButton = false,
  chronologicalIndex = null,
  calculateType = null,
  compact = false
}) => {

  const [image, imageStatus, imageError] = useImageWithAuth('photo_processing', job.thumbnail);

  return (
    <Card className={`job-selection-card ${compact ? 'compact' : ''}`}>
      <div className="d-flex">
        {job.thumbnail && (
          <>
          {imageStatus === 'loading' && (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '40px' }}>
              <Spinner animation="border" size="sm" />
            </div>
          )}

          {imageStatus === 'loaded' && image && (
            <div className="job-image-container">
                <img
                  src={image.src}
                  alt={`Job ${job.id}`}
                  className="job-thumbnail"
                />
                {chronologicalIndex && (
                  <Badge bg="primary" className="chronological-badge">
                    {chronologicalIndex}
                  </Badge>
                )}
              </div>
          )}

          {imageStatus === 'failed' && (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '150px' }}>
              <span className="text-danger">Image load failed</span>
            </div>
          )}
        </>
        )}

        <div className="job-info flex-grow-1">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <h6 className="mb-1">Job #{job.id}</h6>
              {job.original_image_filename && (
                <p className="text-muted small mb-1">{job.original_image_filename}</p>
              )}
              <small className="text-muted">
                {new Date(job.created_at).toLocaleDateString()}
              </small>
              {job.grid_dimensions && (
                <div className="mt-1">
                  <Badge bg="secondary" className="me-1">
                    {job.grid_dimensions[0]}×{job.grid_dimensions[1]}
                  </Badge>
                  {job.crop_type_display && job.crop_type_display !== 'uncropped' && (
                    <Badge bg="info">
                      {job.crop_type_display}
                    </Badge>
                  )}
                </div>
              )}
            </div>

            <div className="job-actions">
              {showAddButton && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={onAdd}
                >
                  <i className="bi bi-plus"></i>
                </Button>
              )}

              {showRemoveButton && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={onRemove}
                >
                  <i className="bi bi-x"></i>
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default JobSelectionCard;